const MetaInfo = {
  de: {
    lang: "de",
    title: "Linkr: Leistungsstarker Link in Bio für Socials | linkr.bio",
    description:
      "Linkr: Bester kostenloser Link in Bio für Social Creators in 2022-2023! Kostenloser Bio-Link-Builder für eine Seite. Generieren Sie einen QR-Code, verkaufen Sie online und teilen Sie Ihr Profil in einem Bio-Link.",
    metas: [
      {
        name: "twitter:title",
        content:
          "Linkr: Leistungsstarker Link in Bio für Social Creators und Influencer",
      },
      {
        name: "twitter:description",
        content:
          "Linkr: Bester kostenloser Link in Bio für Social Creators in 2022-2023! Kostenloser Bio-Link-Builder für eine Seite. Generieren Sie einen QR-Code, verkaufen Sie online und teilen Sie Ihr Profil in einem Bio-Link.",
      },
      {
        name: "twitter:image:src",
        content:
          "https://cdn.static.linkr.bio/static/linkr/home/linkrbio-linkinbio-tool-met-voorbeeld-bio-link-voor-instagram-en-bio-paginafunctie-op-achtergrond-og-preview-twitter.jpg",
      },
      {
        name: "twitter:image:alt",
        content:
          "linkr.bio bester Link in Bio für Ersteller mit Beispielen für Instagram-Bio-Links und Funktionen von Bio-Seiten im Hintergrund",
      },
      {
        property: "og:title",
        content:
          "Linkr: Leistungsstarker Link in Bio für Social Creators und Influencer",
      },
      {
        property: "og:description",
        content:
          "Linkr: Bester kostenloser Link in Bio für Social Creators in 2022-2023! Kostenloser Bio-Link-Builder für eine Seite. Generieren Sie einen QR-Code, verkaufen Sie online und teilen Sie Ihr Profil in einem Bio-Link.",
      },
      {
        property: "og:image",
        content:
          "https://cdn.static.linkr.bio/static/linkr/home/linkrbio-linkinbio-tool-met-voorbeeld-bio-link-voor-instagram-en-bio-paginafunctie-op-achtergrond-og-preview-facebook.png",
      },
      {
        property: "og:image:alt",
        content:
          "linkr.bio bester Link in Bio für Ersteller mit Beispielen für Instagram-Bio-Links und Funktionen von Bio-Seiten im Hintergrund",
      },
      {
        property: "og:locale",
        content: "de",
      },
    ],
  },
  es: {
    lang: "es",
    title:
      "Linkr: enlace poderoso en herramienta bio para redes sociales | linkr.bio",
    description:
      "Linkr: ¡La mejor herramienta gratuita de link in bio para creadores sociales en 2022-2023! Creador gratuito de enlaces biográficos de una página. Genere código QR, venda en línea, comparta su perfil en un enlace biográfico.",
    metas: [
      {
        name: "twitter:title",
        content:
          "Linkr: potente enlace en bio herramienta para creadores sociales e influencers",
      },
      {
        name: "twitter:description",
        content:
          "Linkr: ¡La mejor herramienta gratuita de link in bio para creadores sociales en 2022-2023! Creador gratuito de enlaces biográficos de una página. Genere código QR, venda en línea, comparta su perfil en un enlace biográfico.",
      },
      {
        name: "twitter:image:src",
        content:
          "https://cdn.static.linkr.bio/static/linkr/home/linkrbio-herramienta-linkinbio-con-enlace-bio-de-ejemplo-para-instagram-y-función-de-página-bio-en-segundo-plano-og-preview-twitter.jpg",
      },
      {
        name: "twitter:image:alt",
        content:
          "linkr.bio la mejor herramienta de link in bio para creadores con ejemplos de enlaces biográficos de instagram y características de la página bio en segundo plano",
      },
      {
        property: "og:title",
        content:
          "Linkr: potente enlace en bio herramienta para creadores sociales e influencers",
      },
      {
        property: "og:description",
        content:
          "Linkr: ¡La mejor herramienta gratuita de link in bio para creadores sociales en 2022-2023! Creador gratuito de enlaces biográficos de una página. Genere código QR, venda en línea, comparta su perfil en un enlace biográfico.",
      },
      {
        property: "og:image",
        content:
          "https://cdn.static.linkr.bio/static/linkr/home/linkrbio-herramienta-linkinbio-con-enlace-bio-de-ejemplo-para-instagram-y-función-de-página-bio-en-segundo-plano-og-preview-facebook.png",
      },
      {
        property: "og:image:alt",
        content:
          "linkr.bio la mejor herramienta de link in bio para creadores con ejemplos de enlaces biográficos de instagram y características de la página bio en segundo plano",
      },
      {
        property: "og:locale",
        content: "es",
      },
    ],
  },
  fr: {
    lang: "fr",
    title:
      "Linkr : lien puissant dans l'outil bio pour les réseaux sociaux | linkr.bio",
    description:
      "Linkr : Meilleur outil link in bio gratuit pour les créateurs sociaux en 2022-2023 ! Générateur de lien bio gratuit d'une page. Générez un code QR, vendez en ligne, partagez votre profil dans un lien bio.",
    metas: [
      {
        name: "twitter:title",
        content:
          "Linkr: lien puissant dans l'outil bio pour les créateurs sociaux et les influenceurs",
      },
      {
        name: "twitter:description",
        content:
          "Linkr : Meilleur outil link in bio gratuit pour les créateurs sociaux en 2022-2023 ! Générateur de lien bio gratuit d'une page. Générez un code QR, vendez en ligne, partagez votre profil dans un lien bio.",
      },
      {
        name: "twitter:image:src",
        content:
          "https://cdn.static.linkr.bio/static/linkr/home/outil-linkrbio-linkinbio-avec-exemple-de-lien-bio-pour-instagram-et-fonctionnalité-de-page-bio-en-arrière-plan-og-preview-facebook.jpg",
      },
      {
        name: "twitter:image:alt",
        content:
          "linkr.bio meilleur outil link in bio pour les créateurs avec des exemples de liens bio instagram et des fonctionnalités de page bio en arrière-plan",
      },
      {
        property: "og:title",
        content:
          "Linkr: lien puissant dans l'outil bio pour les créateurs sociaux et les influenceurs",
      },
      {
        property: "og:description",
        content:
          "Linkr : Meilleur outil link in bio gratuit pour les créateurs sociaux en 2022-2023 ! Générateur de lien bio gratuit d'une page. Générez un code QR, vendez en ligne, partagez votre profil dans un lien bio.",
      },
      {
        property: "og:image",
        content:
          "https://cdn.static.linkr.bio/static/linkr/home/outil-linkrbio-linkinbio-avec-exemple-de-lien-bio-pour-instagram-et-fonctionnalité-de-page-bio-en-arrière-plan-og-preview-facebook.png",
      },
      {
        property: "og:image:alt",
        content:
          "linkr.bio meilleur outil link in bio pour les créateurs avec des exemples de liens bio instagram et des fonctionnalités de page bio en arrière-plan",
      },
      {
        property: "og:locale",
        content: "fr",
      },
    ],
  },
  id: {
    lang: "id",
    title: "Linkr: Tautan Kuat di Alat Bio untuk Sosial | linkr.bio",
    description:
      "Linkr: Alat link in bio gratis terbaik untuk pencipta sosial pada 2022-2023! Pembuat tautan bio situs satu halaman gratis. Hasilkan kode QR, jual online, bagikan profil Anda dalam satu tautan bio.",
    metas: [
      {
        name: "twitter:title",
        content:
          "Linkr: Tautan kuat dalam alat bio untuk pencipta dan pemberi pengaruh sosial",
      },
      {
        name: "twitter:description",
        content:
          "Linkr: Alat link in bio gratis terbaik untuk pencipta sosial pada 2022-2023! Pembuat tautan bio situs satu halaman gratis. Hasilkan kode QR, jual online, bagikan profil Anda dalam satu tautan bio.",
      },
      {
        name: "twitter:image:src",
        content:
          "https://cdn.static.linkr.bio/static/linkr/home/alat-linkrbio-linkinbio-dengan-contoh-tautan-bio-untuk-instagram-dan-fitur-halaman-bio-di-latar-belakang-og-preview-twitter.jpg",
      },
      {
        name: "twitter:image:alt",
        content:
          "linkr.bio alat link in bio terbaik untuk pembuat dengan contoh tautan bio instagram dan fitur halaman bio di latar belakang",
      },
      {
        property: "og:title",
        content:
          "Linkr: Tautan kuat dalam alat bio untuk pencipta dan pemberi pengaruh sosial",
      },
      {
        property: "og:description",
        content:
          "Linkr: Alat link in bio gratis terbaik untuk pencipta sosial pada 2022-2023! Pembuat tautan bio situs satu halaman gratis. Hasilkan kode QR, jual online, bagikan profil Anda dalam satu tautan bio.",
      },
      {
        property: "og:image",
        content:
          "https://cdn.static.linkr.bio/static/linkr/home/alat-linkrbio-linkinbio-dengan-contoh-tautan-bio-untuk-instagram-dan-fitur-halaman-bio-di-latar-belakang-og-preview-facebook.png",
      },
      {
        property: "og:image:alt",
        content:
          "linkr.bio alat link in bio terbaik untuk pembuat dengan contoh tautan bio instagram dan fitur halaman bio di latar belakang",
      },
      {
        property: "og:locale",
        content: "id",
      },
    ],
  },
  ja: {
    lang: "ja",
    title: "Linkr: ソーシャル向けの Bio ツールの強力なリンク | linkr.bio",
    description:
      "Linkr:2022-2023 年のソーシャル クリエーター向けの最高の無料 link in bio ツール!無料の 1 ページ サイト バイオ リンク ビルダー.QR コードを生成し、オンラインで販売し、1 つのバイオ リンクでプロフィールを共有します。",
    metas: [
      {
        name: "twitter:title",
        content:
          "Linkr:ソーシャル クリエーターやインフルエンサー向けのバイオ ツールの強力なリンク",
      },
      {
        name: "twitter:description",
        content:
          "Linkr:2022-2023 年のソーシャル クリエーター向けの最高の無料 link in bio ツール!無料の 1 ページ サイト バイオ リンク ビルダー.QR コードを生成し、オンラインで販売し、1 つのバイオ リンクでプロフィールを共有します。",
      },
      {
        name: "twitter:image:src",
        content:
          "https://cdn.static.linkr.bio/static/linkr/home/pic-in-janpanese-linkrbio-linkinbio-tool-with-example-bio-link-for-instagram-and-bio-page-feature-at-background-og-preview-twitter.jpg",
      },
      {
        name: "twitter:image:alt",
        content:
          "linkr.bio Instagramのバイオリンクの例とバックグラウンドでのバイオページ機能を備えたクリエイター向けの最高のlink in bioツール",
      },
      {
        property: "og:title",
        content:
          "Linkr:ソーシャル クリエーターやインフルエンサー向けのバイオ ツールの強力なリンク",
      },
      {
        property: "og:description",
        content:
          "Linkr:2022-2023 年のソーシャル クリエーター向けの最高の無料 link in bio ツール!無料の 1 ページ サイト バイオ リンク ビルダー.QR コードを生成し、オンラインで販売し、1 つのバイオ リンクでプロフィールを共有します。",
      },
      {
        property: "og:image",
        content:
          "https://cdn.static.linkr.bio/static/linkr/home/pic-in-janpanese-linkrbio-linkinbio-tool-with-example-bio-link-for-instagram-and-bio-page-feature-at-background-og-preview-facebook.png",
      },
      {
        property: "og:image:alt",
        content:
          "linkr.bio Instagramのバイオリンクの例とバックグラウンドでのバイオページ機能を備えたクリエイター向けの最高のlink in bioツール",
      },
      {
        property: "og:locale",
        content: "ja",
      },
    ],
  },
  pt: {
    lang: "pt",
    title:
      "Linkr: melhor ferramenta linktree gratuita para link na bio site para instagram | linkr.bio",
    description:
      "Linkr:linktree gratuito link na bio ferramenta para instagram, tiktok, whatsapp diretor e muito mais!Link bio construtor de sites para 2022-2023! Gere código QR, venda online, em um link bio.",
    metas: [
      {
        name: "twitter:title",
        content:
          "Linkr: Ferramenta de link poderoso na bio para criadores e influenciadores sociais",
      },
      {
        name: "twitter:description",
        content:
          "Linkr:linktree gratuito link na bio ferramenta para instagram, tiktok, whatsapp diretor e muito mais!Link bio construtor de sites para 2022-2023! Gere código QR, venda online, em um link bio.",
      },
      {
        name: "twitter:image:src",
        content:
          "https://cdn.static.linkr.bio/static/linkr/home/alat-linkrbio-linkinbio-dengan-contoh-tautan-bio-untuk-instagram-dan-fitur-halaman-bio-di-latar-belakang-og-preview-twitter.jpg",
      },
      {
        name: "twitter:image:alt",
        content:
          "linkr.bio ferramenta link in bio com exemplo de link de biografia para instagram e recurso de página de biografia em segundo plano",
      },
      {
        property: "og:title",
        content:
          "Linkr: Ferramenta de link poderoso na bio para criadores e influenciadores sociais",
      },
      {
        property: "og:description",
        content:
          "Linkr:linktree gratuito link na bio ferramenta para instagram, tiktok, whatsapp diretor e muito mais!Link bio construtor de sites para 2022-2023! Gere código QR, venda online, em um link bio.",
      },
      {
        property: "og:image",
        content:
          "https://cdn.static.linkr.bio/static/linkr/home/linkrbio-ferramenta-linkinbio-com-exemplo-de-link-de-biografia-para-instagram-e-recurso-de-página-de-biografia-em-segundo-plano-e-visualização-de-facebook.png",
      },
      {
        property: "og:image:alt",
        content:
          "linkr.bio ferramenta link in bio com exemplo de link de biografia para instagram e recurso de página de biografia em segundo plano",
      },
      {
        property: "og:locale",
        content: "pt",
      },
    ],
  },
  ru: {
    lang: "ru",
    title: "Linkr: мощная ссылка в Bio для социальных сетей | linkr.bio",
    description:
      "linkr.bio: Лучший бесплатный инструмент link in bio для создателей социальных сетей в 2022-2023 годах! Бесплатный конструктор ссылок на одну страницу сайта. Создавайте QR-код, продавайте онлайн, делитесь своим профилем в одной ссылке на био.",
    metas: [
      {
        name: "twitter:title",
        content:
          "Linkr: мощная ссылка в био-инструменте для создателей социальных сетей и влиятельных лиц.",
      },
      {
        name: "twitter:description",
        content:
          "Linkr: Лучший бесплатный инструмент link in bio для создателей социальных сетей в 2022-2023 годах! Бесплатный конструктор ссылок на одну страницу сайта. Создавайте QR-код, продавайте онлайн, делитесь своим профилем в одной ссылке на био.",
      },
      {
        name: "twitter:image:src",
        content:
          "https://cdn.static.linkr.bio/static/linkr/home/pic-in-janpanese-linkrbio-linkinbio-tool-with-example-bio-link-for-instagram-and-bio-page-feature-at-background-og-preview-twitter.jpg",
      },
      {
        name: "twitter:image:alt",
        content:
          "linkr.bio лучший инструмент link in bio для создателей с примерами био ссылок в Instagram и функциями био страницы на backgroud",
      },
      {
        property: "og:title",
        content:
          "Linkr: мощная ссылка в био-инструменте для создателей социальных сетей и влиятельных лиц.",
      },
      {
        property: "og:description",
        content:
          "Linkr: Лучший бесплатный инструмент link in bio для создателей социальных сетей в 2022-2023 годах! Бесплатный конструктор ссылок на одну страницу сайта. Создавайте QR-код, продавайте онлайн, делитесь своим профилем в одной ссылке на био.",
      },
      {
        property: "og:image",
        content:
          "https://cdn.static.linkr.bio/static/linkr/home/Инструмент-linkrbio-linkinbio-с-примером-ссылки-на-биографию-для-instagram-и-функцией-страницы-биографии-на-заднем-плане-og-preview-facebook.png",
      },
      {
        property: "og:image:alt",
        content:
          "linkr.bio лучший инструмент link in bio для создателей с примерами био ссылок в Instagram и функциями био страницы на backgroud",
      },
      {
        property: "og:locale",
        content: "ru",
      },
    ],
  },
};
export function setMeta(key, value, isProperty) {
  if (isProperty) {
    let property = document.querySelector(`meta[property='${key}']`);
    if (property) {
      property.content = value;
    } else {
      let oMeta = document.createElement("meta");
      oMeta.property = key;
      oMeta.content = value;
      document.getElementsByTagName("head")[0].appendChild(oMeta);
    }
  } else {
    const metas = document.getElementsByTagName("meta");
    if (metas[key]) {
      metas[key].content = value;
    } else {
      let oMeta = document.createElement("meta");
      oMeta.name = key;
      oMeta.content = value;
      document.getElementsByTagName("head")[0].appendChild(oMeta);
    }
  }
}

// 英语的meta信息是默认的，
export function replaceMetaInfo(lang) {
  let curMetaInfo = lang && MetaInfo[lang] ? MetaInfo[lang] : null;
  if (curMetaInfo) {
    // 设置 title
    document.title = curMetaInfo.title;
    // 设置 description
    setMeta("description", curMetaInfo.description, false);
    curMetaInfo.metas.forEach((info) => {
      // name 相关属性，isProperty：false
      let infoKey = info.name || info.property;
      info.content && setMeta(infoKey, info.content, info.name ? false : true);
    });
  }
}
